export default "__VITE_ASSET__220f13d4__"